module.exports = __webpack_public_path__ + "static/img/value-added-left.854642a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/value-added-left.png
// module id = gbkS
// module chunks = 1